module.exports = __webpack_public_path__ + "img/top_lesson.e30a45b8.jpg";